import getConfig from 'next/config';

// Load environment variables if not already loaded
if (typeof process !== 'undefined' && !process.env.API_ENDPOINT) {
  try {
    require('dotenv').config();
  } catch (error) {
    // dotenv might not be available in all environments
  }
}

// Safe configuration getter that handles cases where getConfig is not available
export function getPublicRuntimeConfig() {
  // First try to get from Next.js config
  try {
    const nextConfig = getConfig();
    if (nextConfig?.publicRuntimeConfig?.API_ENDPOINT) {
      return nextConfig.publicRuntimeConfig;
    }
  } catch (error) {
    // getConfig not available during build
  }

  // Fallback to environment variables
  const fallbackConfig = {
    API_ENDPOINT: process.env.API_ENDPOINT || process.env.NEXT_PUBLIC_API_ENDPOINT || 'https://api.talentiq.studio',
    DOMAIN: process.env.DOMAIN || process.env.NEXT_PUBLIC_DOMAIN || 'talentiq.studio',
    SITE_URL: process.env.SITE_URL || process.env.NEXT_PUBLIC_SITE_URL || 'https://talentiq.studio',
    HASH_PW_CLIENT: process.env.HASH_PW_CLIENT || process.env.NEXT_PUBLIC_HASH_PW_CLIENT || 'true',
    MAX_SIZE_IMAGE: process.env.MAX_SIZE_IMAGE || process.env.NEXT_PUBLIC_MAX_SIZE_IMAGE || '100',
    MAX_SIZE_FILE: process.env.MAX_SIZE_FILE || process.env.NEXT_PUBLIC_MAX_SIZE_FILE || '1000',
    MAX_SIZE_TEASER: process.env.MAX_SIZE_TEASER || process.env.NEXT_PUBLIC_MAX_SIZE_TEASER || '200',
    MAX_SIZE_VIDEO: process.env.MAX_SIZE_VIDEO || process.env.NEXT_PUBLIC_MAX_SIZE_VIDEO || '5000'
  };

  return fallbackConfig;
}

// Safe server runtime config getter
export function getServerRuntimeConfig() {
  try {
    const nextConfig = getConfig();
    if (nextConfig?.serverRuntimeConfig?.API_ENDPOINT) {
      return nextConfig.serverRuntimeConfig;
    }
  } catch (error) {
    // getConfig not available during build
  }

  // Fallback to environment variables
  return {
    API_ENDPOINT: process.env.API_SERVER_ENDPOINT || process.env.API_ENDPOINT || 'http://localhost:8080'
  };
}

// Export safe configuration objects
export const publicRuntimeConfig = getPublicRuntimeConfig();
export const serverRuntimeConfig = getServerRuntimeConfig();

// Export individual values with safe parsing
export const API_ENDPOINT = publicRuntimeConfig.API_ENDPOINT;
export const DOMAIN = publicRuntimeConfig.DOMAIN;
export const SITE_URL = publicRuntimeConfig.SITE_URL;
export const HASH_PW_CLIENT = publicRuntimeConfig.HASH_PW_CLIENT;
export const MAX_SIZE_IMAGE = parseInt(publicRuntimeConfig.MAX_SIZE_IMAGE, 10);
export const MAX_SIZE_FILE = parseInt(publicRuntimeConfig.MAX_SIZE_FILE, 10);
export const MAX_SIZE_TEASER = parseInt(publicRuntimeConfig.MAX_SIZE_TEASER, 10);
export const MAX_SIZE_VIDEO = parseInt(publicRuntimeConfig.MAX_SIZE_VIDEO, 10);
